"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OfferHintWrapper = exports.Content = void 0;
var _mui = require("@ori-ui/mui");
const OfferHintWrapper = exports.OfferHintWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  borderRadius: theme.spacing(2),
  boxShadow: `0 3px 6px 0 ${(0, _mui.alpha)(theme.palette.grey[900], 0.05)}`,
  boxSizing: 'border-box',
  marginBottom: theme.spacing(4),
  position: 'relative',
  [theme.breakpoints.only('xs')]: {
    marginBottom: theme.spacing(2)
  }
}));
const Content = exports.Content = (0, _mui.styled)('div')(({
  theme
}) => ({
  background: theme.palette.background.paper,
  border: `2px solid ${(0, _mui.alpha)(theme.palette.grey[900], 0.05)}`,
  borderRadius: theme.spacing(0, 0, 2, 2),
  borderTop: 0,
  position: 'relative'
}));